import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { color } from "src/styles/variables";

function CouponBanner({ children, ...props }) {
  return (
    <Bubble data-selector="CouponAppliedMessage" {...props}>
      {children}
    </Bubble>
  );
}

export default CouponBanner;

CouponBanner.propTypes = {
  children: PropTypes.any.isRequired,
};

const Bubble = styled.p`
  font-weight: 400;
  background-color: ${color.mineShaft};
  color: ${color.white};
  padding: 8px;
  text-align: center;
  margin-bottom: 0;
`;
